module.exports = __webpack_public_path__ + "media/images/emoticons/id-828646b6a86512f596ddc2f45ff6c6fd.gif";